<div class="input-group">
  <select *ngIf="options$ | async as options" id="title" class="form-select" (change)="handlerChangeOrder($event)">
    <option *ngFor="let item of options" [selected]="this.selectedOption.code === item.code" value="{{ item.code }}">
      {{ item.label }}
    </option>
  </select>
</div>
